export default __webpack_public_path__ + "media/images/app-icon-212b8b533f26babbf7ae6b7d17950081.svg";